import { useApi } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { PlaceCard } from "@/pages/Search";
import { useLang } from "@/lib/i18n";

export default function PlacesIndex({ kind }) {
  const { t } = useLang();
  const { data, loading } = useApi(`/places?kind=${kind}`, []);
  const k = kind === "activity" ? "todo" : "areas";
  return (
    <>
      <Seo title={t(`${k}.seoTitle`)} description={t(`${k}.seoDesc`)} />
      <PageHeader testId={`${k}-header`} eyebrow={t(`${k}.eyebrow`)} title={t(`${k}.title`)}>{t(`${k}.intro`)}</PageHeader>
      <section className="container-x pb-28" data-testid={`${k}-index`}>
        {!loading && (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {data.map((p, i) => <Reveal key={p.slug} delay={(i % 3) * 0.08}><PlaceCard p={p} /></Reveal>)}
          </div>
        )}
      </section>
    </>
  );
}
